import { Application } from "@hotwired/stimulus"
import CollapsibleController from "./collapsible_controller"
import ConnectionStatusController from "./connection_status_controller"
import FeedFilterController from "./feed_filter_controller"
import InstallPromptController from "./install_prompt_controller"
import MobileMenuController from "./mobile_menu_controller"
import PrereqCellController from "./prereq_cell_controller"
import PrereqNotesController from "./prereq_notes_controller"
import RowLinkController from "./row_link_controller"
import SweeperActivityController from "./sweeper_activity_controller"
import SweeperProgrammaController from "./sweeper_programma_controller"
import SweeperRoomsController from "./sweeper_rooms_controller"
import SweeperEditorCountermeasuresController from "./sweeper_editor_countermeasures_controller"
import SweeperEditorFailureModesController from "./sweeper_editor_failure_modes_controller"
import SweeperEditorMetadataController from "./sweeper_editor_metadata_controller"
import SweeperEditorResourcesController from "./sweeper_editor_resources_controller"
import SweeperEditorShellController from "./sweeper_editor_shell_controller"
import SweeperEditorVerdictController from "./sweeper_editor_verdict_controller"
import SweeperEditorVirtuesController from "./sweeper_editor_virtues_controller"
import SweeperShellController from "./sweeper_shell_controller"
import TimetableToggleController from "./timetable_toggle_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application
application.register("collapsible", CollapsibleController)
application.register("connection-status", ConnectionStatusController)
application.register("feed-filter", FeedFilterController)
application.register("install-prompt", InstallPromptController)
application.register("mobile-menu", MobileMenuController)
application.register("prereq-cell", PrereqCellController)
application.register("prereq-notes", PrereqNotesController)
application.register("row-link", RowLinkController)
application.register("sweeper-activity", SweeperActivityController)
application.register("sweeper-programma", SweeperProgrammaController)
application.register("sweeper-rooms", SweeperRoomsController)
application.register("sweeper-editor-countermeasures", SweeperEditorCountermeasuresController)
application.register("sweeper-editor-failure-modes", SweeperEditorFailureModesController)
application.register("sweeper-editor-metadata", SweeperEditorMetadataController)
application.register("sweeper-editor-resources", SweeperEditorResourcesController)
application.register("sweeper-editor-shell", SweeperEditorShellController)
application.register("sweeper-editor-verdict", SweeperEditorVerdictController)
application.register("sweeper-editor-virtues", SweeperEditorVirtuesController)
application.register("sweeper-shell", SweeperShellController)
application.register("timetable-toggle", TimetableToggleController)

export { application }
